<div class="thp-form-container" id="pay-transparency-container">
  <div class="thp-form">
    <h2 class="pay-rate-title">{{'talent-happy-path.pay-transparency.pay-rate.title' | translate}}</h2>
    <p class="pay-range">{{'talent-happy-path.pay-transparency.pay-rate.pay-range' | translate:{min: minPay | currency, max: maxPay | currency} }}</p>
    <form [formGroup]="payTransparencyForm" >
      <mat-form-field class="form-field">
        <mat-label>{{payRateHeader}}</mat-label>
        <span matTextPrefix>{{'currency-symbol' | translate}} &nbsp;</span>
        <input type="text" matInput formControlName="payRate" placeholder="" id="pay-rate" (input)="filterPayRateInput()" (blur)="formatPayRate()">
      </mat-form-field>
    </form>
    <div *ngIf="payTransparencyResponseData?.length <= (this.lowRespondentThreshold)" id="pay-transparency-message-container">
      <img src="assets/icons/info icon.svg" alt="Info" class="info-icon" />
      <p class="pay-transparency-message" *ngIf="!payTransparencyResponseData || payTransparencyResponseData.length === 0">
        You’re the first to respond, your rate helps set the benchmark.
      </p>
      <p class="pay-transparency-message" *ngIf="payTransparencyResponseData && payTransparencyResponseData.length > 0 && payTransparencyResponseData.length <= lowRespondentThreshold">
        You are an early applicant, these insights will get stronger as more data comes in.
      </p>
    </div>

    <div id="pay-transparency-response-chart-container">
      <app-pay-transparency-response-chart
        [candidateRate]="payTransparencyForm.get('payRate').value"
        [payTransparencyData]="payTransparencyData">
      </app-pay-transparency-response-chart>
    </div>

  </div>


  <div class="button-container">
    <button id="iiq-splash-page-next-button" mat-flat-button class="custom-button" (click)="isSubmitModalVisible = true" [disabled]="payTransparencyForm.get('payRate').invalid || payTransparencyForm.get('payRate').value === ''">
      {{ buttonTextKey | translate }}
    </button>
    <button *ngIf="!hideDoThisLaterButton" id="iiq-splash-page-do-later" mat-button class="later-button" (click)="isLaterModalVisible = true">
      {{ "talent-happy-path.buttons.do-later" | translate }}
    </button>
    <!-- [navigateToThankYou]="false" prevents automatic navigation to /thank-you page when "I'll do this later" is confirmed -->
    <app-confirmation-modal
      [isVisible]="isLaterModalVisible"
      [navigateToThankYou]="false"
      (isVisibleChange)="isLaterModalVisible = $event"
      header="{{'talent-happy-path.pay-transparency.later-modal.header' | translate}}"
      description="{{'talent-happy-path.pay-transparency.later-modal.description' | translate}}"
      (cancel)="isLaterModalVisible = false"
      (confirm)="clickIllDoThisLater(); isLaterModalVisible  = false">
    </app-confirmation-modal>
    <app-confirmation-modal
      [isVisible]="isSubmitModalVisible"
      [navigateToThankYou]="false"
      (isVisibleChange)="isSubmitModalVisible = $event"
      header="{{'talent-happy-path.pay-transparency.submit-modal.header' | translate}}"
      description="{{'talent-happy-path.pay-transparency.submit-modal.description' | translate}}"
      (cancel)="isSubmitModalVisible = false"
      (confirm)="submitPayTransparency(); isSubmitModalVisible = false">
    </app-confirmation-modal>
  </div>
</div>
